module.exports = __webpack_public_path__ + "assets/logo-rating.ce84804f.svg";